import * as ActionTypes from '../ActionTypes';

export const GetCompanyConfigurationAction = (params) => {
    return {
        type: ActionTypes.COMPANY_CONFIG_GET_REQUEST,
        params
    }
}

export const UpdateCompanyConfigurationAction = (params) => {
    return {
        type: ActionTypes.COMPANY_CONFIG_UPDATE_REQUEST,
        params
    }
}